export default function emailAddress(value, { validate = false, locale = {} }) {
  const emailAddress = /.+@.+\..+/i;

  // we just wants to do a validation step, only
  if (validate) {
    return emailAddress.test(value);
  }

  /** @description CB-19336 Phase1: all that is required is "*@*.*" */
  if (!emailAddress.test(value)) {
    return locale.emailAddress || locale['common.emailAddress.error'] || 'Email not valid';
  }

  return null;
}
